import { SplitResponsiveManager } from './splitManager';
import { splitButtonManager } from './splitButtonManager';
import { effectManager } from './effectManager';
import _ from 'lodash';
import EventMg, { EventType } from './EventManager';

export class LayoutManager {
  constructor() {
    this.title = 'LayoutManager';

    //delegate オブジェクト
    this.navigationDelegate = null;
    this.heightDelegate = null;

    //要素
    this.memberWidth = [];
    this.memberHeight = [];
    this.memberPauseHeight = [];

    //splitmanager
    //分割画面内のレスポンシブを設定
    this.splitManager = null;
    this.splitButtonManager = null;
  }

  init() {
    //console.log("LayoutManager init ---------- ");
    this.memberWidth = [];
    this.memberHeight = [];

    //分割画面にレスポンシブクラスを付与
    this.splitManager = new SplitResponsiveManager();
    this.splitManager.init();

    //分割画面のボタンの状態
    this.splitButtonManager = new splitButtonManager();
    this.splitButtonManager.init();
  }

  forceUpdate() {
    this.updateElementHeight();
    this.updateElementWidth();
    EventMg.trigger(EventType.LAYOUT_UPDATE, {});
  }

  //ナビゲーションデリゲート登録
  setNavigationDelegate(delegate) {
    //this.navigationDelegate = delegate;
    delegate.observeNavi((e, status) => {
      this.updateElementWidth(status);
      this.updateElementHeight();
    });

    //SplitResponsiveManger
    this.splitManager.setDelegate(delegate);
    this.splitButtonManager.setDelegate(delegate);
  }

  //高さデリゲート登録
  setHeightDelegate(delegate) {
    this.heightDelegate = delegate;
    this.heightDelegate.setDelegate(() => {
      this.updateElementHeight();
    });
  }

  //要素の高さ設定
  setHeightUpdateElement(selecter) {
    this.memberHeight.push(selecter);
  }

  //高さ更新を一時停止
  pauseHeightUpdateElement(selecter) {
    this.memberPauseHeight.push(selecter);
  }

  //高さ更新を一時停止から削除
  removePauseHeightUpdateElement(selecter) {
    _.pull(this.memberPauseHeight, selecter);
  }

  //要素の横幅設定
  //effectManager
  setWidthUpdateElement(id, key) {
    var elements = {
      funcnavi1: '#func-navi--item1',
      funcnavi2: '#func-navi--item2',
    };

    if (!document.querySelector(id)) {
      return;
    }

    let _target = new effectManager(id, [elements[key]], [key]);
    this.memberWidth.push(_target);
  }

  //高さ更新
  updateElementHeight() {
    setTimeout(() => {
      _.each(this.memberHeight, member => {
        const pause = _.filter(this.memberPauseHeight, value => {
          console.log('updateHeight = ', member, value);
          return value == member;
        });

        if (!_.size(pause)) {
          var target = document.querySelector(member);
          if (target) {
            // if (
            //   document.querySelector(
            //     '.main__body .table--notification-table'
            //   ) !== null
            // ) {
            //   target.style.height = `${window.innerHeight -
            //     target.getBoundingClientRect().top +
            //     1200}px`;
            // } else {
            //   target.style.height = `${window.innerHeight -
            //     target.getBoundingClientRect().top}px`;
            // }
            target.style.height = `${window.innerHeight -
              target.getBoundingClientRect().top}px`;
          }
        }
      });
    }, 100);
  }

  //幅更新
  updateElementWidth(status) {
    if (!status) {
      return;
    }
    //console.log("LayoutManager update width" , status );

    _.each(this.memberWidth, member => {
      member
        .before(setDefaultValue => {
          //事前処理
          var global_width = window.innerWidth;
          if (status.masternavi) {
            global_width -= 210;
          }
          if (status.splitview1 && status.splitview2) {
            global_width /= 2;
          }
          setDefaultValue(global_width);
        })
        .subAffect(effecter => {
          // 減算していく関数
          if (status[effecter.tag]) {
            return effecter.element.getBoundingClientRect().width;
          }
          return 0;
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/utilities/layoutManager.js